<mat-dialog-content class="p-0 videos" *ngIf="data">
    <button mat-button type="button" (click)="closeDialog()"><i class="fas fa-times"></i></button>
	<video name="media" class="w-100" controls autoplay loop *ngIf="data.type === 'video'">
        <source src="{{data.item.announcement_image.videoUrl}}" type="{{data.item.announcement_image.mimetype}}">
    </video>
    <ng-container *ngIf="data.type === 'iframe'">
        <div class="text iframe-video" [innerHtml]="data.item.content | safewidget: 'html'"></div>
    </ng-container>
    
</mat-dialog-content>